var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "bj-modal",
        {
          attrs: {
            size: { width: "800px", minWidth: "800px", maxWidth: "800px" },
            title: _vm.modalTitle
          },
          model: {
            value: _vm.visible,
            callback: function($$v) {
              _vm.visible = $$v
            },
            expression: "visible"
          }
        },
        [
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _vm.isEditMode
                ? _c("div", [
                    _c(
                      "div",
                      { staticClass: "row gutter-sm" },
                      [
                        _c(
                          "q-field",
                          {
                            staticClass: "col-8",
                            attrs: {
                              error: _vm.$v.payload.property_id.$error,
                              "error-label": "This field is required"
                            }
                          },
                          [
                            _c("autocomplete", {
                              attrs: {
                                method: "autocompleteShowingProperty",
                                placeholder: "Showing Property..."
                              },
                              on: {
                                change: _vm.propertySelected,
                                clear: _vm.propertySelected
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "q-field",
                          {
                            staticClass: "col-4",
                            attrs: { default: "Manual" }
                          },
                          [
                            _c("q-select", {
                              attrs: {
                                "float-label": "Source",
                                options: _vm.sources
                              },
                              model: {
                                value: _vm.payload.inquiry_source_id,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.payload,
                                    "inquiry_source_id",
                                    $$v
                                  )
                                },
                                expression: "payload.inquiry_source_id"
                              }
                            })
                          ],
                          1
                        ),
                        _vm.hasMultipleUnits
                          ? _c(
                              "q-field",
                              {
                                staticClass: "col-4",
                                attrs: {
                                  error: _vm.$v.payload.unit_id.$error,
                                  "error-label": "This field is required"
                                }
                              },
                              [
                                _c("select-property-unit", {
                                  attrs: {
                                    units: _vm.payload.property.units,
                                    "property-id": _vm.payload.property_id,
                                    "current-unit-id": _vm.payload.unit_id
                                  },
                                  on: { change: _vm.unitSelected }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.userRoleIs(
                          this.$config.roles.ACCOUNT_OWNER,
                          this.$config.roles.MEMBER
                        )
                          ? _c(
                              "q-field",
                              { staticClass: "col-12" },
                              [
                                _c("q-input", {
                                  attrs: {
                                    type: "textarea",
                                    "float-label": "Comments"
                                  },
                                  model: {
                                    value: _vm.payload.comments,
                                    callback: function($$v) {
                                      _vm.$set(_vm.payload, "comments", $$v)
                                    },
                                    expression: "payload.comments"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                : _c("div", [
                    _vm.currentStep === "inquiry"
                      ? _c(
                          "div",
                          { staticClass: "row gutter-sm" },
                          [
                            _c(
                              "q-field",
                              {
                                staticClass: "col-3",
                                attrs: {
                                  error: _vm.$v.payload.first_name.$error,
                                  "error-label": "This field is required"
                                }
                              },
                              [
                                _c("q-input", {
                                  attrs: {
                                    "float-label": "Prospect First Name"
                                  },
                                  model: {
                                    value: _vm.payload.first_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.payload, "first_name", $$v)
                                    },
                                    expression: "payload.first_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "q-field",
                              { staticClass: "col-3" },
                              [
                                _c("q-input", {
                                  attrs: {
                                    "float-label": "Prospect Last Name"
                                  },
                                  model: {
                                    value: _vm.payload.last_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.payload, "last_name", $$v)
                                    },
                                    expression: "payload.last_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "q-field",
                              {
                                staticClass: "col-3",
                                attrs: {
                                  error: _vm.$v.payload.email.$error,
                                  "error-label":
                                    "You must fill a valid email address"
                                }
                              },
                              [
                                _c("q-input", {
                                  attrs: {
                                    type: "email",
                                    "float-label": "Prospect Email Address"
                                  },
                                  model: {
                                    value: _vm.payload.email,
                                    callback: function($$v) {
                                      _vm.$set(_vm.payload, "email", $$v)
                                    },
                                    expression: "payload.email"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "q-field",
                              {
                                staticClass: "col-3",
                                attrs: {
                                  error: _vm.$v.payload.phone_number.$error,
                                  "error-label":
                                    "You must fill a valid phone number"
                                }
                              },
                              [
                                _c("q-input", {
                                  attrs: {
                                    type: "tel",
                                    "float-label": "Prospect Phone Number"
                                  },
                                  model: {
                                    value: _vm.payload.phone_number,
                                    callback: function($$v) {
                                      _vm.$set(_vm.payload, "phone_number", $$v)
                                    },
                                    expression: "payload.phone_number"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "q-field",
                              {
                                staticClass: "col-8",
                                attrs: {
                                  error: _vm.$v.payload.property_id.$error,
                                  "error-label": "This field is required"
                                }
                              },
                              [
                                _c("autocomplete", {
                                  attrs: {
                                    method: "autocompleteShowingProperty",
                                    placeholder: "Showing Property..."
                                  },
                                  on: {
                                    change: _vm.propertySelected,
                                    clear: _vm.propertySelected
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "q-field",
                              {
                                staticClass: "col-4",
                                attrs: { default: "Manual" }
                              },
                              [
                                _c("q-select", {
                                  attrs: {
                                    "float-label": "Source",
                                    options: _vm.sources
                                  },
                                  model: {
                                    value: _vm.payload.inquiry_source_id,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.payload,
                                        "inquiry_source_id",
                                        $$v
                                      )
                                    },
                                    expression: "payload.inquiry_source_id"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm.hasMultipleUnits
                              ? _c(
                                  "q-field",
                                  {
                                    staticClass: "col-4",
                                    attrs: {
                                      error: _vm.$v.payload.unit_id.$error,
                                      "error-label": "This field is required"
                                    }
                                  },
                                  [
                                    _c("select-property-unit", {
                                      attrs: {
                                        units: _vm.payload.property.units,
                                        "property-id": _vm.payload.property_id,
                                        "current-unit-id": _vm.payload.unit_id
                                      },
                                      on: { change: _vm.unitSelected }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            !_vm.userRoleIs(
                              this.$config.roles.ACCOUNT_OWNER,
                              this.$config.roles.MEMBER
                            )
                              ? _c(
                                  "q-field",
                                  { staticClass: "col-12" },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        type: "textarea",
                                        "float-label": "Comments"
                                      },
                                      model: {
                                        value: _vm.payload.comments,
                                        callback: function($$v) {
                                          _vm.$set(_vm.payload, "comments", $$v)
                                        },
                                        expression: "payload.comments"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            !_vm.isPublishListing
                              ? _c(
                                  "div",
                                  { staticClass: "col-12 q-mt-sm" },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "q-mb-xs text-weight-medium"
                                      },
                                      [
                                        _vm._v(
                                          "\n            Who will schedule the tour?\n          "
                                        )
                                      ]
                                    ),
                                    _c("q-field", [
                                      _c(
                                        "div",
                                        [
                                          _c("q-radio", {
                                            attrs: {
                                              val: "self",
                                              label:
                                                "Prospect will schedule their own tour"
                                            },
                                            model: {
                                              value: _vm.scheduleMode,
                                              callback: function($$v) {
                                                _vm.scheduleMode = $$v
                                              },
                                              expression: "scheduleMode"
                                            }
                                          }),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-grey-7 q-ml-xl q-mb-sm"
                                            },
                                            [
                                              _vm._v(
                                                "\n                Showdigs will text the prospect a link to complete pre-screening and schedule their tour.\n              "
                                              )
                                            ]
                                          ),
                                          _c("q-radio", {
                                            attrs: {
                                              val: "pm",
                                              label:
                                                "I’ll schedule the tour for them"
                                            },
                                            model: {
                                              value: _vm.scheduleMode,
                                              callback: function($$v) {
                                                _vm.scheduleMode = $$v
                                              },
                                              expression: "scheduleMode"
                                            }
                                          }),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-grey-7 q-ml-xl q-mb-none"
                                            },
                                            [
                                              _vm._v(
                                                "\n                Schedule on the prospect’s behalf now and text them the tour details.\n              "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  { staticClass: "col-12 text-grey-7" },
                                  [
                                    _vm._v(
                                      "\n          When the showing type is updated to include tour availability, you will be able to notify prospects that tours are available.\n        "
                                    )
                                  ]
                                )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.currentStep === "details"
                      ? _c("div", { staticClass: "row gutter-sm" }, [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c(
                                "p",
                                { staticClass: "q-mb-xs text-weight-medium" },
                                [
                                  _vm._v(
                                    "\n            Who will host the tour?\n          "
                                  )
                                ]
                              ),
                              _c("autocomplete", {
                                attrs: {
                                  method: "autocompleteAgent",
                                  filters: {
                                    is_tours_capable: true,
                                    property_id: _vm.payload.property_id
                                  },
                                  placeholder: "Agent..."
                                },
                                on: {
                                  change: _vm.matchAnAgentSelected,
                                  clear: _vm.matchAnAgentSelected
                                }
                              })
                            ],
                            1
                          ),
                          _c("div", { staticClass: "col-12 q-mt-sm" }, [
                            _c(
                              "p",
                              { staticClass: "q-mb-xs text-weight-medium" },
                              [
                                _vm._v(
                                  "\n            What type of tour will this be?\n          "
                                )
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "tour-type-radio-group" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "tour-type-radio-option",
                                    class: {
                                      "tour-type-radio-option-active": !_vm
                                        .payload.is_video
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.setTourType(false)
                                      }
                                    }
                                  },
                                  [
                                    _c("q-radio", {
                                      attrs: {
                                        value: _vm.payload.is_video,
                                        val: false,
                                        label: "In-person tour"
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.setTourType(false)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "tour-type-radio-option",
                                    class: {
                                      "tour-type-radio-option-active":
                                        _vm.payload.is_video
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.setTourType(true)
                                      }
                                    }
                                  },
                                  [
                                    _c("q-radio", {
                                      attrs: {
                                        value: _vm.payload.is_video,
                                        val: true,
                                        label: "Live video tour"
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.setTourType(true)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm.currentStep === "dateTime"
                      ? _c("div", { staticClass: "row gutter-sm" }, [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _vm.schedulerUnit
                                ? _c("bj-unit-schedule-tour", {
                                    attrs: {
                                      unit: _vm.schedulerUnit,
                                      "is-video": _vm.payload.is_video,
                                      "assignee-id": _vm.payload.agent_id,
                                      "chosen-assignee-label":
                                        _vm.chosenAssigneeLabel
                                    },
                                    on: {
                                      "time-selected":
                                        _vm.onScheduleTourTimeSelected
                                    }
                                  })
                                : _c("p", { staticClass: "text-grey-7" }, [
                                    _vm._v(
                                      "\n            Choose a property and unit to pick a tour date and time.\n          "
                                    )
                                  ])
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ]),
              _c("bj-inner-loading", {
                attrs: { label: "Saving", visible: _vm.loading }
              })
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "q-btn-group",
                { attrs: { rounded: "", flat: "" } },
                [
                  !_vm.isEditMode
                    ? _c("q-btn", {
                        attrs: {
                          disable: _vm.loading,
                          rounded: "",
                          size: "lg",
                          outline: "",
                          label: _vm.backLabel,
                          "no-caps": ""
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.goBack($event)
                          }
                        }
                      })
                    : _vm._e(),
                  _c("q-btn", {
                    attrs: {
                      disable: _vm.loading || _vm.nextDisabled,
                      rounded: "",
                      color: "primary",
                      icon: "save",
                      size: "lg",
                      outline: "",
                      label: _vm.nextLabel,
                      "no-caps": ""
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.goNext($event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }